<template>
  <div class="cmp-gpt-main-navigation-bar">
    <div @click.prevent="onLogoClick" class="details-logo" style="cursor:pointer">
      <img
        :src="'./static/icons/details_d.PNG'"
        alt
        srcset
      />
      <span>detailsGPT </span>

      <div class="dt-icon-container" @click.stop="$emit('newChat')">
        <img src="static/icons/edit.svg" class="close-icon dt-icon v5 h1 s3" alt />
      </div>
    </div>
    <!-- <div class="navbar-options">
      <div class="dt-icon-container close-button" @click.stop="closseMainNav">
        <img
          src="static/icons/edit.svg"
          class="close-icon dt-icon v5 h1 s3"
          style="filter: grayscale(1)"
          alt
        />
      </div>
    </div> -->
    <!-- <v-list class="main-nav-list">
      <v-list-group
        v-for="item in items"
        :value="isModuleActive($route, item)"
        :key="item.title"
        no-action
      >
        <v-list-tile class="main-menu" slot="activator">
          <v-list-tile-content>
            <v-list-tile-title
              class="main-menu--title"
              :class="{
                active: isModuleActive($route, item),
              }"
            >
              <div class="main-menu--icon">
                <img :src="item.img" alt="calendar" />
              </div>
              <div
                class="main-menu--text"
                @click.prevent="onParentNavClick(item)"
              >
                <template v-if="item.tkey">{{ $t(item.tkey) }}</template>
                <template v-else>
                  <template v-if="base == 'main'">{{
                    $t(item.title)
                  }}</template>
                  <template v-else>
                    {{item.title  }}
                    <a :to="item.title">
                      <router-link tag="li" :to="'/' + base + '/' + item.route">
                        <template>{{ $t(item.tkey) }} </template>
                      </router-link>
                    </a>
                  </template>
                </template>
              </div>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-for="subItem in item.children"
          :key="subItem.title"
          class="sub-menu--title"
          :class="{
            active: isSubmenuActive($route, item, subItem),
            'has-details-list': subItem.children && subItem.children.length,
          }"
          @click="onNavItemClick(item, subItem)"
        >
          <router-link
            tag="li"
            :to="'/' + base + '/' + item.route + '/' + subItem.route"
          >
            <a :to="subItem.title">
              <template v-if="subItem.tkey"
                >{{ $dft.capHead($t(subItem.tkey)) }}
                <div v-if="subItem.badge" class="badge">
                  {{ subItem.badge }}
                </div>
              </template>
              <template v-else
                >{{ subItem.title }}
                <div class="badge" v-if="subItem.badge">
                  {{ subItem.badge }}
                </div>
              </template>
            </a>
          </router-link>
          <div
            class="details-list"
            v-if="subItem.children && subItem.children.length > 0"
          >
            <div
              v-for="details in subItem.children"
              :key="details.route"
              class="details--title"
              :class="{
                active: isDetailsActive($route, item, subItem, details),
              }"
              :title="details.full_title"
              @click.stop="onDetailsItemClick(item, subItem, details)"
            >
              <div class="text">
                {{ details.title }}
              </div>
              <div class="button">
                <img
                  @click.stop="onCloseDetails(item, subItem, details)"
                  src="static/icons/minus-circle.svg"
                  class="dt-icon v5"
                  alt="Close"
                  title="Close"
                />
              </div>
            </div>
          </div>
        </v-list-tile>
      </v-list-group>
    </v-list> -->
    <div class="menu">
      <div class="section">
        <h2>Contacts</h2>
        <ul>
          <li>Stephan Rombach</li>
          <li>BMG Publishing</li>
          <li><a href="#" @click.prevent="$emit('itemClicked')">List contacts all</a></li> 
          <li><a href="#" @click.prevent="$emit('itemClicked')">Filter: France</a></li>
          <li>(thing I asked about contacts)</li>
          <li>(thing 2 asked about contacts)</li>
          <li>(thing 3 asked about contacts)</li>
        </ul>
      </div>
      <div class="section">
        <h2>Repertoire</h2>
        <ul>
          <li>Missing releases</li>
          <li>Import from IDOL</li>
          <li>Import GEMA</li>
          <li>(thing I asked about repertoire)</li>
          <li>(thing 2 asked about repertoire)</li>
          <li>(thing 3 asked about repertoire)</li>
          <li>Import from IDOL</li>
          <li>Import GEMA</li>
          <li>(thing I asked about repertoire)</li>
          <li>(thing 2 asked about repertoire)</li>
          <li>(thing 3 I asked about repertoire)</li>
          <li>(thing 4 I asked about repertoire)</li>
        </ul>
      </div>
      <div class="section">
        <h2>Royalties</h2>
        <ul>
          <li>(thing I asked about royalties)</li>
          <li>(thing 2 I asked about royalties)</li>
          <li>(thing 3 I asked about royalties)</li>
          <li>(thing 4 I asked about royalties)</li>
          <li>(thing I asked about royalties)</li>
          <li>(thing 2 I asked about royalties)</li>
          <li>(thing 3 I asked about royalties)</li>
          <li>(thing 4 I asked about royalties)</li>
          <li>(thing I asked about royalties)</li>
          <li>(thing 2 I asked about royalties)</li>
          <li>(thing 3 I asked about royalties)</li>
          <li>(thing 4 I asked about royalties)</li>
          <li>(thing (etc) I asked about royalties)</li>
        </ul>
      </div>
      <div class="section">
        <h2>Payments</h2>
        <ul>
          <li>What payments still need to be done</li>
          <li>(thing I asked about payments)</li>
          <li>(thing I asked about payments)</li>
          <li>(thing 2 I asked about payments)</li>
          <li>(thing 3 I asked about payments)</li>
          <li>(thing 4 I asked about payments)</li>
          <li>(thing I asked about payments)</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../modules/b2b/store/types.js";
import { mapGetters } from "vuex";
import { SET_MAIN_NAV_ACTIVE } from "../../../store/app/types";
import { BookingDetails } from "../../../modules/booking/store/types";
import {
  handleCloseTab,
  handleCloseTabRoute,
} from "../../../dt-plugins/sidewindow/nav-tab";

import * as ActionTypes from "../../../store/app/types";

export default {
  props: {
    base: {
      type: String,
      default: "main",
    },
    items: {
      type: Array,
    },
    value: {
      required: false,
    },
  },
  computed: {},
  methods: {
    onParentNavClick: function (item) {
      if (item.route == "booking") {
        this.$store.dispatch(ActionTypes.FETCH_REQUEST_COUNT);
      }
    },
    closseMainNav: function () {
      this.$emit("closeMainNav", true);
    },
    isSubmenuActive: function (route, item, submenu) {
      const routePattern = new RegExp(
        `/${this.base}/${item.route.toLowerCase()}/${submenu.route.toLowerCase()}`,
        "ig"
      );
      // console.log(routePattern, route.path);
      const isMatch = routePattern.exec(route.path);
      return isMatch;
    },
    isDetailsActive: function (route, item, submenu, details) {
      const routePattern = new RegExp(
        `/${
          this.base
        }/${item.route.toLowerCase()}/${submenu.route.toLowerCase()}/${details.route.toLowerCase()}.*`,
        "ig"
      );
      // console.log(routePattern, route.path);
      const isMatch = routePattern.exec(route.path);
      return isMatch;
    },
    isModuleActive: function (route, item) {
      const routePattern = new RegExp(`/${this.base}/${item.route.toLowerCase()}`, "ig");
      const isMatch = routePattern.exec(route.path);
      return isMatch;
    },
    onNavItemClick: function (item, subItem) {
      this.$store.commit(SET_MAIN_NAV_ACTIVE, true);
      console.log(
        "Log: item, subItem, details",
        `/${this.base}/${item.route}/${subItem.route}`
      );
      this.$router.push({
        path: `/${this.base}/${item.route}/${subItem.route}`,
      });
    },
    onDetailsItemClick: function (item, subItem, details) {
      if (details.hideSideWindow) {
        this.$router.push({
          path: `/${this.base}/${item.route}/${subItem.route}/${details.route}`,
        });
      } else {
        this.$store.commit(SET_MAIN_NAV_ACTIVE, true);
        const tab = this.$route.params.tab || "overview";

        this.$router.push({
          path: `/${this.base}/${item.route}/${subItem.route}/${details.route}/${tab}`,
        });
      }
    },
    onCloseDetails: function (item, subItem, details) {
      console.log("details", details);
      console.log("item", item);
      console.log("subItem", subItem);
      if (details.hideSideWindow) {
        this.$store.dispatch(ActionTypes.DELETE_SIDE_NAV_ITEM, details);
        this.$router.push({
          path: `/${this.base}/${item.route}/${subItem.route}`,
        });
      } else {
        // const module = this.$store.getters.appNavItems.find(e => 'distribu');
        // const submodule = module.children.find();
        // const details = submodule.find();

        //console.log()
        handleCloseTab(this.$store, item, subItem, details);
      }
    },
    onLogoClick: function () {
      console.log("Logo clicked");
      this.$emit('logoclick', true);
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.main-nav {
  &.inactive {
    // background: blue;

    --text-accent: var(--text-accent-inactive);
    --sprt-85: var(--sprt-2);
    --sprt-95: var(--sprt-6);
    --bc-5: var(--bc-5-inactive);
    --bc-6: var(--bc-6-inactive);
  }
  .cmp-gpt-main-navigation-bar {
    // Z Index is required so users can select this on top of the Version UI
    z-index: 1;
    .navbar-options {
      width: 50px;
      margin: 5px 0px;
      button {
        margin-right: 5px;
        .close-icon {
          width: 40px;
          height: 40px;
          filter: grayscale(1);
        }
      }

      .close-button {
        // float: right;
        // margin-top: -80px;
      }
    }

    .details-logo {
      display: flex;
      // justify-content: center;
      margin-top: 10px;
      flex-direction: row;
      padding: 0 5px;

      img {
        width: 15%;
        height: 15%;
      }
      span {
        font-size: 120%;
        padding-left: 5px;
        color: var(--text-primary);
        font-family: "Roboto", sans-serif;
      }
      .dt-icon-container {
        img {
          width: 26px;
          height: 26px;
          text-align: right;
          margin-left: 35px;
        }
      }
    }

    .menu {
      max-width: 400px;
      margin: 0 auto;
      padding: 20px;

      .section {
        margin-bottom: 20px;
        h2 {
          color: #333;
          font-size: 18px;
          margin-bottom: 10px;
        }
        ul {
          list-style-type: none;
          padding: 0;
          margin: 0;
        }
        ul {
          li {
            margin: 5px 0;
          }
        }
        a {
          color: #0066cc;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    .main-nav-list {
      margin-top: 30px;

      .list__group {
        // margin: 0px 10px;

        &--active {
          .main-menu {
            background: var(--bc-6);
          }

          &::before,
          &::after {
            background: none !important;
          }
        }

        &:after {
          background-color: var(--sprt-85);
          height: 1px;
        }
        .list__group__header {
          text-transform: uppercase;
          margin: 0px -10px;

          .main-menu {
            .list__tile {
              // color: var(--text-2);
              font-size: 13px;
              height: 38px;
              padding: 0px 20px;
              .main-menu--title {
                display: flex;
                font-size: 13px;
                .main-menu--icon {
                  flex: 1;
                  margin-top: -8px;
                }
                .main-menu--text {
                  flex: 4;
                }

                &.active {
                  color: var(--text-accent);
                  .main-menu--icon {
                    filter: invert(44%) sepia(29%) saturate(3658%) hue-rotate(359deg)
                      brightness(100%) contrast(107%);
                  }
                }
              }
            }
          }

          .list__group__header__append-icon {
            display: none;
          }

          &:hover {
            background: none !important;
            color: var(--text-accent);
          }
        }

        .list__group__items {
          list-style-type: none;

          margin-top: -7px;
          margin-left: -28px;
          margin-right: -38px;
          background: var(--bc-6);

          .sub-menu--title {
            // text-transform: uppercase;
            margin-left: 6px;
            li > a {
              font-size: 12px !important;
            }
            .list__tile {
              // color: var(--text-2);
            }

            &:hover {
              background: var(--bc-5);
            }

            &.active {
              background: var(--bc-5);
            }

            a {
              font-size: 13px;
              height: 18px;

              // margin: 10px 0px;      // Creates problem after assigning event handler to parent sub-menu--title

              color: var(--text-primary);
              text-decoration-line: none;

              &:hover {
                text-decoration: none;
              }
            }

            .list__tile--link {
              // padding-left: 72px;
              height: 28px;
              li {
                margin: 0 0px;

                &.has-details-list {
                  // margin-left: -105px;
                }
              }
              &:hover {
                background: none !important;
                text-decoration: none;
                text-decoration-color: var(--text-accent);
              }
            }

            &.has-details-list {
              .list__tile--link {
                display: flex;
                flex-direction: column;
                height: 100%;
                li {
                  // margin-left: -105px;
                  width: 100%;
                }
                .details-list {
                  margin-left: -30px;
                  padding: 5px 0px;
                  font-size: 12px;
                  .details--title {
                    font-size: 11px;
                    display: flex;
                    padding: 4px 0px 4px 7px;
                    border-left: 1px solid #979797;

                    .text {
                      width: 120px;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                    }

                    .button {
                      margin-left: 5px;

                      // height: 20px;
                      // width:  20px;
                      img {
                        opacity: 0;
                        transition: 200ms ease-out;

                        margin: -3px -3px -3px -7px;
                        height: 15px;
                        width: 15px;

                        &:hover {
                          background: none;
                        }
                      }
                    }

                    &:hover {
                      .button {
                        img {
                          opacity: 1;
                        }
                      }
                    }

                    &.active {
                      font-weight: 450;
                      padding-left: 6px;
                      border-left: 2px solid #707070;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .badge {
    padding: 2px;
    background-color: var(--bc-accent-dark);
    border-radius: 100px;
    margin-left: 5px;
    width: 19px;
    text-align: center;
    font-size: 10px;
    color: #fff;
    font-weight: 900;
  }
}

// .active {
//   background-color: #d8d5d5;
// }
</style>
